import PageHeader from "@/components/PageHeader";
import Seo from "@/components/Seo";

const Barrierefreiheit = () => (
  <>
      <Seo title="Barrierefreiheitserklärung | Rewe Kotlarski" description="Erklärung zur Barrierefreiheit der Website von Rewe Kotlarski in Meerbusch-Osterath nach WCAG 2.2 AA." />
    <PageHeader tag="Rechtliches" title={"Barrierefreiheits-\nerklärung"} />
    <section className="py-16 px-6 md:px-16">
      <div className="max-w-3xl mx-auto font-body text-muted-foreground space-y-8 [&_h2]:font-display [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-foreground [&_h2]:mb-3 [&_h2]:[hyphens:none] [&_p]:leading-relaxed" style={{ textWrap: "pretty" as any }}>
        <div>
          <h2>Erklärung zur Barrierefreiheit</h2>
          <p>
            REWE Markt ist bemüht, seine Website im Einklang mit den nationalen Rechtsvorschriften zur Umsetzung der Richtlinie (EU) 2016/2102 des Europäischen Parlaments und des Rates barrierefrei zugänglich zu machen.
          </p>
        </div>

        <div>
          <h2>Stand der Vereinbarkeit mit den Anforderungen</h2>
          <p>
            Diese Website ist teilweise mit den Web Content Accessibility Guidelines (WCAG) 2.1 Level AA vereinbar. Wir arbeiten kontinuierlich daran, die Barrierefreiheit zu verbessern.
          </p>
        </div>

        <div>
          <h2>Maßnahmen zur Barrierefreiheit</h2>
          <ul className="list-disc pl-6 space-y-2 mt-2">
            <li>Semantisches HTML für eine klare Dokumentstruktur</li>
            <li>Hohe Farbkontraste für gute Lesbarkeit</li>
            <li>Alternative Texte für alle Bilder</li>
            <li>Tastaturnavigation für alle interaktiven Elemente</li>
            <li>Klare Fokus-Indikatoren für die Tastaturnutzung</li>
            <li>Responsive Design für alle Gerätegrößen</li>
          </ul>
        </div>

        <div>
          <h2>Feedback und Kontaktangaben</h2>
          <p>
            Sollten Ihnen Mängel in Bezug auf die barrierefreie Gestaltung auffallen, können Sie uns gerne kontaktieren:
          </p>
          <p className="mt-2">
            E-Mail:{" "}
            <a
              href="mailto:info@rewe-musterstadt.de"
              className="text-primary-bright hover:text-primary-bright/80 transition-colors underline"
            >
              info@rewe-musterstadt.de
            </a>
          </p>
          <p>Telefon: 0123 / 456 789 0</p>
        </div>

        <div>
          <h2>Durchsetzungsverfahren</h2>
          <p>
            Wenn wir auf Ihre Anfrage nicht zufriedenstellend reagieren, können Sie sich an die zuständige Durchsetzungsstelle wenden.
          </p>
        </div>

        <div>
          <h2>Datum dieser Erklärung</h2>
          <p>Diese Erklärung wurde am 25. Februar 2026 erstellt.</p>
        </div>
      </div>
    </section>
  </>
);

export default Barrierefreiheit;